import React, { useEffect } from 'react';
import './ExperienceSection.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { experienceOrder } from '../data/experience';
import { useLanguage } from '../hooks/useLanguage';

const ExperienceSection = () => {
  const { t } = useLanguage();

  useEffect(() => {
    AOS.init({ duration: 900, once: true });
  }, []);

  return (
    <section className="experience" id="experience" data-aos="fade-up">
      <div className="experience-content">
        <h2 className="section-heading" data-aos="flip-left">{t.experience.title}</h2>
        <div className="experience-list">
          {experienceOrder.map((id) => {
            const job = t.experience[id];
            return (
              <div key={id} className="experience-card">
                <h3>{job.role} <span>@ {job.company}</span></h3>
                <p className="duration">{job.duration}</p>
                <p>{job.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;

